import React from 'react';
import './App.css';
import AppRouter from "./router/AppRouter";

function App() {

    function getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    window.addEventListener('resize', () => {
        // получаем текущее значение высоты
        let vh = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
// Пример использования
    const screenWidth = getScreenWidth();

  return (
      <div className="App">
        <div className='container'>
          <AppRouter/>
        </div>
      </div>
  );
}

export default App;
